import { helper as buildHelper } from "@ember/component/helper"
import { dateFormatMap } from "../lib/date-formatter"

export function fastDateObject(params, hash) {
  let dateString = params[0]
  return dateFormatMap(dateString)
}

export default buildHelper(fastDateObject)
